export const AiTaggingRepository = Symbol.for('AiTaggingRepository');
